/**
 * Base URL of this app's own API.
 *
 * Its own module so the session-refresh call can read it without importing the
 * API client — that client imports the refresh, and a cycle between the two
 * leaves one of them undefined at module-evaluation time.
 */
export const API_BASE = import.meta.env.VITE_API_URL || 'http://localhost:3001'
